import { Visibility, VisibilityOff } from '@mui/icons-material';

interface Props {
  dossierViewed: boolean;
}

const DossierViewedIcon = ({ dossierViewed }: Props): JSX.Element =>
  dossierViewed ? <Visibility /> : <VisibilityOff />;
export default DossierViewedIcon;
